import { IDENTITY_API_BASE_URL } from '@/core/constants/appConfig/environment';
import { ScriptHandler } from '@/core/handlers/script';
import { callWgsAPI } from '@/shared/fetch_client';
import { Logger } from '@/shared/logger/logger';

import {
  CommonSessionAndOrBrowserResponse,
  PatchSessionAndOrBrowserRequest,
  PatchUpdateUpdateSessionIdMappingRequest,
  PostSessionAndOrBrowserRequest,
} from './types';

// API Service
const IdentityApiService = {
  /**
   * Creates a new session and browser (if provided).
   * @param data - The data to create a session and/or browser.
   * @returns The response indicating success and possibly the new identity ID.
   */
  async createSessionAndOrBrowser(
    data: PostSessionAndOrBrowserRequest,
  ): Promise<CommonSessionAndOrBrowserResponse> {
    return Logger.profileFnAsync(
      'IdentityApiService:createSessionAndOrBrowser',
      async () => {
        const response = await callWgsAPI<CommonSessionAndOrBrowserResponse>({
          body: JSON.stringify(data satisfies PostSessionAndOrBrowserRequest),
          method: 'POST',
          params: {
            uid: ScriptHandler.getInstance().getSourceUid(),
          },
          url: `${IDENTITY_API_BASE_URL}${IdentityApiService.route}/session`,
        });
        return response.data;
      },
      undefined,
      false,
    );
  },

  route: '/id2',

  /**
   * Updates an existing session and/or browser.
   * @param data - The data to update a session and/or browser.
   * @returns The response indicating success.
   */
  async updateSessionAndOrBrowser(
    data: PatchSessionAndOrBrowserRequest,
  ): Promise<CommonSessionAndOrBrowserResponse> {
    return Logger.profileFnAsync(
      'IdentityApiService:updateSessionAndOrBrowser',
      async () => {
        const response = await callWgsAPI<CommonSessionAndOrBrowserResponse>({
          body: JSON.stringify(data),
          method: 'PATCH',
          params: {},
          url: `${IDENTITY_API_BASE_URL}${IdentityApiService.route}/session`,
        });
        return response.data;
      },
      undefined,
      false,
    );
  },

  async updateSessionIdMapping(
    data: PatchUpdateUpdateSessionIdMappingRequest,
  ): Promise<boolean> {
    return Logger.profileFnAsync(
      'IdentityApiService:updateSessionIdMapping',
      async () => {
        const response = await callWgsAPI<boolean>({
          body: JSON.stringify(data),
          method: 'POST',
          params: {},
          url: `${IDENTITY_API_BASE_URL}${IdentityApiService.route}/mapping`,
        });
        return response.data;
      },
      undefined,
      false,
    );
  },
};

export default IdentityApiService;
